<template>
  <base-entity-card
    :id="id"
    titleName="вопроса"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="false"
  >
    <v-form ref="form" v-model="isValid">
    
      <v-textarea
        label="Вопрос *"
        v-model="entity.name"
        :rules="[v => !!v || 'Введите вопрос.']"
        filled
      ></v-textarea>
      <v-combobox
        label="Тэги"
        v-model="entity.tags"
        multiple
        small-chips
        filled
      ></v-combobox>
      
      <v-md-editor v-model="entity.htmlAnswer" height="400px"></v-md-editor>

    </v-form>
  </base-entity-card>
</template>

<script>
import SiteEntityMixin from '../../../models/SiteEntityMixin';

export default {
  name: 'site-question-card',

  mixins: [SiteEntityMixin],

  data() {
    return {
      tag: 'question',
    }
  },

  methods: {
    getDefaultEntity() {
      return {
        site: null,
        name: '',
        tags: [],
        htmlAnswer: ''
      }
    },
  },
}
</script>